import { MenuEntry } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'

const config: (t: ContextApi['t']) => MenuEntry[] = (t) => [
  {
    label: t('Home'),
    icon: 'HomeIcon',
    href: '/',
  },

  
  {
    label: t('Trade'),
    icon: 'TradeIcon',
    items: [
      {
        label: t('Exchange'),
        href: '/swap?outputCurrency=0xb26820dacbcc00ef870d56f4e81905239cc2acb6',
      },
      {
        label: t('Liquidity'),
        href: '/pool',
      },
    ],
  },

  {
    label: t('Farms'),
    icon: 'FarmIcon',
    href: '/farms',
  },
  {
    label: t('Pools'),
    icon: 'PoolIcon',
    href: '/pools',
  }, 

  {
    label: t('More'),
    icon: 'MoreIcon',

    items: [
      {
				label: t('Info'),
				icon: 'InfoIcon',
				href: 'https://info.axiomadex.com',
				}, 
       {
        label: t('Docs'),
        icon: 'InfoIcon',
        href: 'https://docs.axiomadex.com',
      }, 
    ],
  }, 
]

export default config
